import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Box, Typography, CircularProgress } from "@mui/material";
import { getData } from "../../Services/getData";
import { endpoints, localUrlEnum } from "../../Utils/UrlEnum";
import { Vocabulary } from "../../Utils/Vocabulary";
import { isFreeSubscription } from "../../Utils/Utils";

export default function SimulateExam() {
  const location = useLocation();
  const navigate = useNavigate();
  const stateClientId = location.state?.clientId;
  const clientId = stateClientId || localStorage.getItem("clientId");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!clientId) {
      // If no clientId, redirect back
      navigate(localUrlEnum.questionnaire);
      return;
    }

    // Fetch available categories for this client
    const fetchAvailableCategories = async () => {
      try {
        setLoading(true);
        const response = await getData(
          `${
            endpoints.examQuestions.availableCategories
          }/${clientId}?isFreeSubscription=${isFreeSubscription()}`
        );

        if (response?.data && response.data.length > 0) {
          const categories = response.data;

          if (categories.length === 1) {
            // Only one category, navigate directly to exam with product/category
            const category = categories[0];
            // if _id is defined than it is a product, if not it is a category
            const productId = category._id ? category._id : undefined;
            navigate(
              `${localUrlEnum.examQuestions}?${
                productId
                  ? `productId=${productId}`
                  : `examCategory=${category.name}`
              }`
            );
          } else {
            // Multiple categories, navigate to choose exam simulation
            navigate(localUrlEnum.chooseExamsSimulation, {
              state: { categories, clientId },
            });
          }
        } else {
          // No categories available
          navigate(localUrlEnum.questionnaire);
        }
      } catch (error) {
        console.error("Error fetching available categories:", error);
        navigate(localUrlEnum.questionnaire);
      } finally {
        setLoading(false);
      }
    };

    fetchAvailableCategories();
  }, [clientId, navigate]);

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "88vh",
          gap: 2,
        }}
      >
        <CircularProgress size={60} />
        <Typography variant="h6" color="text.secondary">
          {Vocabulary.loading}
        </Typography>
      </Box>
    );
  }

  return null;
}
